/**
 * tours.js
 * Definição de todos os roteiros do tutorial guiado (Spotlight Tour).
 * Dados puros — sem React.
 */

export const TOURS = [
  {
    id: 'mapa-navegacao',
    titulo: 'Mapa e Navegação',
    icone: '🗺️',
    descricao: 'Aprenda a navegar pelo mapa interativo, usar zoom e explorar os dados geoespaciais do território.',
    totalPassos: 5,
    steps: [
      {
        id: 'mapa-intro',
        titulo: 'O Mapa Interativo',
        texto: 'Esta é a área principal do painel! Aqui você visualiza todos os dados geoespaciais sobre saneamento básico nos municípios brasileiros. Clique em qualquer feição para ver informações detalhadas.',
        selector: '.mapview-wrapper',
      },
      {
        id: 'mapa-munbar',
        titulo: 'Município Selecionado',
        texto: 'Esta barra exibe o município e o horizonte de planejamento do PMSB atualmente selecionados. Clique para trocar rapidamente entre os municípios disponíveis.',
        selector: '.mapview-mun-bar',
      },
      {
        id: 'mapa-zoom',
        titulo: 'Controles de Zoom',
        texto: 'Use os botões + e − para aproximar ou afastar o mapa. O botão de bandeira centraliza a visão no Brasil. Você também pode usar a roda do mouse ou gestos de pinça no celular.',
        selector: '.map-zoom-controls',
      },
      {
        id: 'mapa-toolbar',
        titulo: 'Barra de Ferramentas',
        texto: 'Aqui ficam as ferramentas avançadas: exportação de dados, troca de mapa base (satélite, relevo, ruas) e consulta de atributos das feições. Explore cada botão!',
        selector: '.map-toolbar',
      },
      {
        id: 'mapa-fim',
        titulo: 'Pronto para explorar!',
        texto: 'Agora você conhece todas as partes do mapa. Com as camadas certas ativas no painel lateral, você pode fazer análises territoriais completas sobre o saneamento básico.',
        selector: '.mapview-wrapper',
      },
    ],
  },
  /*{
    id: 'catalogo-camadas',
    titulo: 'Catálogo de Camadas',
    icone: '📚',
    descricao: 'Descubra como ativar, desativar e organizar as camadas de dados geoespaciais no painel lateral.',
    totalPassos: 5,
    steps: [
      {
        id: 'sidebar-intro',
        titulo: 'Painel Lateral',
        texto: 'O painel lateral é o catálogo de dados do painel. Aqui ficam organizadas todas as camadas WMS disponíveis, agrupadas por tema. Clique nos ícones para explorar.',
        selector: '.sidebar',
      },
      {
        id: 'sidebar-iconbar',
        titulo: 'Barra de Ícones dos Grupos',
        texto: 'Cada ícone representa um grupo temático de camadas (saneamento, infraestrutura, território e outros). Clique em um ícone para expandir o painel daquele grupo.',
        selector: '.sb-iconbar',
      },
      {
        id: 'sidebar-panel',
        titulo: 'Painel de Camadas',
        texto: 'Ao clicar em um ícone, o painel expande mostrando as categorias e camadas disponíveis, cada uma com um toggle para ativar no mapa. Clique em um ícone da barra para abrir este painel!',
        selector: '.sb-panel',
        fallback: 'Para ver o painel de camadas, clique em qualquer ícone na barra lateral esquerda. O painel só aparece após selecionar um grupo.',
      },
      {
        id: 'sidebar-busca',
        titulo: 'Catálogo Completo',
        texto: 'Para uma visão completa de todos os grupos e camadas com descrições, acesse a página "Catálogo" no menu superior. Lá você encontra metadados e informações sobre cada conjunto de dados.',
        selector: '.site-header__nav',
      },
      {
        id: 'sidebar-fim',
        titulo: 'Camadas no Mapa!',
        texto: 'Com as camadas ativas, os dados aparecem imediatamente sobre o mapa. Você pode ativar múltiplas camadas simultaneamente e ajustar a opacidade de cada uma.',
        selector: '.sidebar',
      },
    ],
  },*/
  {
    id: 'acessibilidade',
    titulo: 'Acessibilidade',
    icone: '♿',
    descricao: 'Conheça os recursos de acessibilidade: contraste, fonte, VLibras e navegação por teclado.',
    totalPassos: 4,
    steps: [
      {
        id: 'a11y-bar',
        titulo: 'Barra de Acessibilidade',
        texto: 'Esta barra no topo oferece controles de acessibilidade em conformidade com a LBI 13.146/2015, o Decreto 10.645/2021 e o E-MAG do Governo Digital Brasileiro.',
        selector: '.a11y-bar',
      },
      {
        id: 'a11y-fonte',
        titulo: 'Tamanho de Fonte',
        texto: 'Os botões A−, A e A+ ajustam o tamanho do texto em toda a interface. A configuração é salva automaticamente para sua próxima visita.',
        selector: '.a11y-bar',
      },
      {
        id: 'a11y-contraste',
        titulo: 'Alto Contraste',
        texto: 'O botão de alto contraste ativa o tema preto com texto e destaques em amarelo, indicado para pessoas com baixa visão. Atende ao WCAG 2.1 AA (contraste mínimo 4.5:1).',
        selector: '.a11y-bar',
      },
      {
        id: 'a11y-tema',
        titulo: 'Tema Claro / Escuro',
        texto: 'O botão de sol/lua no cabeçalho alterna entre o tema escuro (padrão) e o tema claro. Escolha o que for mais confortável para os seus olhos!',
        selector: '.theme-btn',
      },
    ],
  },
  {
    id: 'cabecalho-menus',
    titulo: 'Cabeçalho e Menus',
    icone: '🧭',
    descricao: 'Navegue pelo cabeçalho, entenda os links de menu, o botão de tema e as opções de acesso.',
    totalPassos: 4,
    steps: [
      {
        id: 'header-intro',
        titulo: 'Cabeçalho Principal',
        texto: 'O cabeçalho está sempre visível no topo e contém o logotipo do Projeto Saneamento Vivo, os menus de navegação e os controles de tema e acesso ao sistema.',
        selector: '.site-header',
      },
      {
        id: 'header-nav',
        titulo: 'Menu de Navegação',
        texto: 'Os links Tutorial, Catálogo, Sobre e Fale Conosco levam você às páginas informativas do painel. O link da página atual fica destacado.',
        selector: '.site-header__nav',
      },
      {
        id: 'header-tema',
        titulo: 'Botão de Tema',
        texto: 'Clique no ícone de sol ou lua para alternar entre o tema claro e escuro. A preferência é salva no seu navegador e aplicada automaticamente na próxima visita.',
        selector: '.theme-btn',
      },
      {
        id: 'header-login',
        titulo: 'Botão de Acesso',
        texto: 'Gestores municipais, prestadoras de serviço e moderadores fazem login aqui para acessar camadas restritas e funcionalidades avançadas de gestão.',
        selector: '.header-login-btn',
        fallback: 'O botão "Entrar" aparece quando você não está autenticado. Se estiver logado, faça logout para visualizar este elemento.',
      },
    ],
  },
  {
    id: 'login-perfis',
    titulo: 'Login e Perfis de Acesso',
    icone: '🔑',
    descricao: 'Entenda os perfis de acesso disponíveis e como o login personaliza sua experiência no painel.',
    totalPassos: 3,
    steps: [
      {
        id: 'login-btn',
        titulo: 'Entrando no Painel',
        texto: 'Clique em "Entrar" para fazer login. O painel suporta quatro perfis: Moderador (regulador), Gestor Municipal (prefeitura), Prestadora (empresa de saneamento) e Sociedade (acesso público sem login).',
        selector: '.header-login-btn',
        fallback: 'O botão de acesso fica no cabeçalho, à direita. Caso já esteja logado, faça logout para ver este elemento.',
      },
      {
        id: 'login-perfis-header',
        titulo: 'Perfis de Acesso',
        texto: 'Cada perfil tem permissões específicas. O perfil Sociedade acessa todos os dados públicos sem precisar fazer login. Os outros perfis têm acesso a camadas restritas e painéis de gestão.',
        selector: '.site-header',
      },
      {
        id: 'login-lgpd',
        titulo: 'Privacidade (LGPD)',
        texto: 'O painel trata seus dados em conformidade com a Lei 13.709/2018 (LGPD). Coleta mínima, finalidade clara e links para a Política de Privacidade e Termos de Uso ficam no rodapé.',
        selector: '.app-footer',
      },
    ],
  },
  {
    id: 'trocar-mapa-base',
    titulo: 'Trocar o Mapa Base',
    icone: '🌍',
    descricao: 'Aprenda a alternar entre os mapas base disponíveis: satélite, relevo, ruas e outros.',
    totalPassos: 4,
    steps: [
      {
        id: 'basemap-toolbar',
        titulo: 'Barra de Ferramentas do Mapa',
        texto: 'A barra lateral direita do mapa reúne as ferramentas principais. Um dos botões abre o seletor de mapa base — você pode trocar a camada de fundo a qualquer momento.',
        selector: '.map-toolbar',
      },
      {
        id: 'basemap-btn',
        titulo: 'Botões de Ferramenta',
        texto: 'Cada botão da barra ativa uma ferramenta: troca de mapa base, adição de camadas WMS, rótulos e geolocalização. Clique no ícone de camadas para abrir o seletor de mapa base.',
        selector: '.map-toolbar-btn',
        autoAdvance: true,
      },
      {
        id: 'basemap-panel',
        titulo: 'Painel de Mapa Base',
        texto: 'Após clicar, o painel de mapa base se expande mostrando as opções disponíveis: OpenStreetMap, satélite, relevo e outros. Clique em qualquer opção para trocar instantaneamente.',
        selector: '.map-toolbar-layer-panel',
        fallback: 'Clique no botão de camadas na barra de ferramentas à direita do mapa para abrir o painel de seleção de mapa base.',
      },
      {
        id: 'basemap-fim',
        titulo: 'Mapa base trocado!',
        texto: 'O mapa base aparece sob todas as camadas de dados. Escolha o que melhor contrasta com as camadas ativas para facilitar a leitura visual dos dados do PMSB.',
        selector: '.mapview-wrapper',
      },
    ],
  },
  {
    id: 'adicionar-camada-wms',
    titulo: 'Inserir Camada WMS',
    icone: '📡',
    descricao: 'Veja como adicionar camadas WMS externas ao mapa diretamente pela barra de ferramentas.',
    totalPassos: 4,
    steps: [
      {
        id: 'wms-toolbar',
        titulo: 'Barra de Ferramentas',
        texto: 'Além das camadas do catálogo, você pode inserir camadas WMS externas de qualquer servidor GeoServer ou WMS público. O botão de adição fica na barra de ferramentas do mapa.',
        selector: '.map-toolbar',
      },
      {
        id: 'wms-add-btn',
        titulo: 'Botão Adicionar Camada',
        texto: 'Clique no botão "+" na barra de ferramentas para abrir o painel de adição de camada WMS. Você precisará informar a URL do servidor e o nome da camada.',
        selector: '.map-toolbar-btn',
        autoAdvance: true,
      },
      {
        id: 'wms-add-panel',
        titulo: 'Painel de Adição WMS',
        texto: 'Preencha a URL do serviço WMS (ex: https://geoserver.exemplo.gov.br/wms) e o nome da camada. A camada é carregada e exibida imediatamente sobre o mapa.',
        selector: '.map-toolbar-add-panel',
        fallback: 'Clique no botão "+" na barra de ferramentas à direita do mapa para abrir o formulário de adição de camada WMS.',
      },
      {
        id: 'wms-fim',
        titulo: 'Camada WMS adicionada!',
        texto: 'A nova camada aparece ativa no mapa e na lista de camadas ativas no painel lateral. Você pode ajustar a opacidade e remover a camada quando não precisar mais.',
        selector: '.sb-actives',
        fallback: 'A seção de camadas ativas aparece no painel lateral após adicionar e ativar pelo menos uma camada.',
      },
    ],
  },
  {
    id: 'baixar-dados',
    titulo: 'Baixar Dados (Shape)',
    icone: '⬇️',
    descricao: 'Saiba como exportar dados das camadas ativas em Shapefile e outros formatos pela barra de ações do mapa.',
    totalPassos: 4,
    steps: [
      {
        id: 'export-ativar',
        titulo: 'Ative uma Camada Primeiro',
        texto: 'Para exportar dados, você precisa ter ao menos uma camada ativa no mapa. Ative-a no painel lateral clicando no ícone de um grupo e habilitando o toggle da camada.',
        selector: '.sb-iconbar',
      },
      {
        id: 'export-header',
        titulo: 'Barra de Ações do Mapa',
        texto: 'Quando há camadas ativas, esta barra aparece no topo do mapa com informações sobre a camada e botões de ação — incluindo o botão de download de dados.',
        selector: '.map-header',
        fallback: 'Esta barra aparece automaticamente no topo do mapa assim que você ativa uma camada no painel lateral.',
      },
      {
        id: 'export-btn',
        titulo: 'Botão de Download',
        texto: 'Clique no botão de download para exportar os dados da camada ativa. Dependendo da camada, o arquivo gerado pode estar em formato Shapefile (.shp), GeoJSON ou CSV.',
        selector: '.map-header-btn',
        fallback: 'O botão de download fica na barra de ações que aparece no topo do mapa quando uma camada está ativa.',
        autoAdvance: true,
      },
      {
        id: 'export-fim',
        titulo: 'Dados baixados!',
        texto: 'O arquivo pode ser aberto em QGIS, ArcGIS, Google Earth ou qualquer software GIS. Use os dados do PMSB para análises externas, relatórios técnicos e cruzamentos com outras bases.',
        selector: '.mapview-wrapper',
      },
    ],
  },
  {
    id: 'trocar-periodo',
    titulo: 'Trocar o Período do PMSB',
    icone: '📅',
    descricao: 'Aprenda a alternar entre os horizontes de planejamento: Situacional, Imediata, Curto, Médio e Longo Prazo.',
    totalPassos: 5,
    steps: [
      {
        id: 'periodo-barra',
        titulo: 'Barra do Município e Período',
        texto: 'Esta barra no topo do mapa exibe o município e os horizontes (elaboração e implementação – 20 anos). Aqui você troca o contexto temporal dos dados exibidos.',
        selector: '.mapview-mun-bar',
      },
      {
        id: 'periodo-trigger',
        titulo: 'Seletor de Período',
        texto: 'Clique no seletor de horizonte para abrir o dropdown com os cinco períodos do PMSB. Cada período corresponde a uma fase do planejamento e implementação do saneamento.',
        selector: '.ms-period-wrap',
        fallback: 'O seletor de período fica na barra superior do mapa. Se não estiver visível, selecione primeiro um município no wizard inicial.',
        autoAdvance: true,
      },
      {
        id: 'periodo-dropdown',
        titulo: 'Horizontes Disponíveis',
        texto: 'Os horizontes são: Situacional (2024–2026), Imediata (2027–2029), Curto Prazo (2030–2034), Médio Prazo (2035–2038) e Longo Prazo (2039–2046). Os horizontes de implementação serão atualizados conforme as próximas etapas do Painel.',
        selector: '.ms-period-dropdown',
        fallback: 'Clique no seletor de período na barra do mapa para abrir o dropdown com os horizontes. Somente o Situacional está disponível nesta versão.',
      },
      {
        id: 'periodo-municipio',
        titulo: 'Trocar o Município',
        texto: 'Ao lado do período, o seletor de município permite alternar entre os municípios disponíveis. As camadas ativas são atualizadas automaticamente para o novo contexto selecionado.',
        selector: '.ms-trigger',
        fallback: 'O seletor de município fica na barra superior do mapa, ao lado do seletor de período.',
        autoAdvance: true,
      },
      {
        id: 'periodo-fim',
        titulo: 'Contexto atualizado!',
        texto: 'Ao trocar o período, todas as camadas ativas são recarregadas para o novo horizonte temporal. Isso permite comparar o diagnóstico situacional com as metas de implementação futura.',
        selector: '.mapview-wrapper',
      },
    ],
  },
  {
    id: 'personalizar-camada',
    titulo: 'Personalizar uma Camada',
    icone: '🎨',
    descricao: 'Ajuste a opacidade, visibilidade e outras propriedades de cada camada ativa no mapa.',
    totalPassos: 5,
    steps: [
      {
        id: 'custom-ativar',
        titulo: 'Ative uma Camada Primeiro',
        texto: 'Para personalizar, primeiro ative uma camada no painel lateral clicando em um grupo de ícones e depois no toggle da camada desejada. Camadas ativas aparecem na seção inferior do painel.',
        selector: '.sb-iconbar',
      },
      {
        id: 'custom-actives',
        titulo: 'Seção de Camadas Ativas',
        texto: 'A seção "Mapas Ativos" no rodapé do painel lateral lista todas as camadas ativadas. Cada card mostra o nome, uma prévia da cor e os controles de personalização.',
        selector: '.sb-actives',
        fallback: 'Ative pelo menos uma camada no painel lateral para ver a seção de camadas ativas aqui.',
      },
      {
        id: 'custom-card',
        titulo: 'Card da Camada Ativa',
        texto: 'Cada camada ativa tem seu próprio card com controles. Clique no botão de personalização (ícone de ajuste) para expandir as opções avançadas como opacidade e visibilidade.',
        selector: '.sb-actives-body',
        fallback: 'Ative uma camada e clique na seta para expandir a seção de camadas ativas.',
      },
      {
        id: 'custom-opacity',
        titulo: 'Controle de Opacidade',
        texto: 'O controle deslizante de opacidade vai de 0% (invisível) a 100% (totalmente opaco). Reduza a opacidade para sobrepor dados de múltiplas camadas sem perder a leitura de nenhuma delas.',
        selector: '.lyc-opacity',
        fallback: 'O controle de opacidade aparece dentro do painel de personalização de cada camada ativa. Clique no botão de ajuste em um card de camada ativa para acessá-lo.',
      },
      {
        id: 'custom-fim',
        titulo: 'Camada personalizada!',
        texto: 'Além da opacidade, você pode alternar a visibilidade temporariamente sem desativar a camada. Experimente combinar camadas com opacidades diferentes para criar visualizações ricas.',
        selector: '.sb-actives',
        fallback: 'Ative uma camada para acessar os controles de personalização.',
      },
    ],
  },
];

export function getTourById(id) {
  return TOURS.find((t) => t.id === id) ?? null;
}
